module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "upload-page mx-5",
    class: {
      page: !_vm.onMobile
    }
  }, [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('v-container', {
    staticClass: "margin-top-header",
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "mb-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'UploadAlbum'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadMusic"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-left my-4"
  }, [_c('h3', [_vm._v("Audio")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Upload audio files & assigned collaborators & splits\n              ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'AddProduct'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadProduct"
  }), _vm._v(" "), _c('div', {
    staticClass: " text-left my-4"
  }, [_c('h3', [_vm._v("Digital product")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Upload zip files, set splits & recoup cost\n              ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoCreate'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadLive"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-left my-4"
  }, [_c('h3', [_vm._v("Broadcast")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Stream live video to your audience\n              ")])])])])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mt-5"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_vm._v("\n        Upload\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-subtitle"
  }, [_vm._v("Add content directly to YouSound for instant worldwide distribution")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46465822","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload/index.vue
// module id = 1708
// module chunks = 180